
import { Badge } from "@/components/ui/badge";
import { Calendar, MapPin } from "lucide-react";

interface ProfileDetailsProps {
  displayName: string;
  age: number;
  distance: number;
  bio: string;
  publicInterests: string[];
}

const ProfileDetails = ({
  displayName,
  age,
  distance,
  bio,
  publicInterests
}: ProfileDetailsProps) => {
  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-2xl font-bold">{displayName || "Anonymous"}</h2>
          <div className="flex items-center text-muted-foreground mt-1">
            <Calendar className="w-4 h-4 mr-1" />
            <span>{age} years old</span>
          </div>
          <div className="flex items-center text-muted-foreground mt-1">
            <MapPin className="w-4 h-4 mr-1" />
            <span>{distance}km away</span>
          </div>
        </div>
      </div>

      {bio && (
        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          {bio}
        </p>
      )}

      {publicInterests?.length > 0 && (
        <div className="mb-6">
          <h3 className="font-semibold mb-2">Interests</h3>
          <div className="flex flex-wrap gap-1">
            {publicInterests.map((interest, index) => (
              <Badge key={index} variant="outline" className="text-xs">
                {interest}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileDetails;
